import tzLookup from "@photostructure/tz-lookup";

export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

// IANA time zone for a point on Earth, looked up offline (oceans give Etc/GMT±N).
export function timeZoneAt(latitude: number, longitude: number): string {
  try {
    return tzLookup(latitude, longitude);
  } catch {
    return BROWSER_TZ;
  }
}

// Minutes east of UTC for `timeZone` at the instant `date` (includes daylight saving).
export function zoneOffsetMinutes(date: Date, timeZone: string): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(date);
  const get = (t: string) => Number(parts.find((p) => p.type === t)?.value);
  const asUtc = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second"));
  return Math.round((asUtc - Math.floor(date.getTime() / 1000) * 1000) / 60_000);
}

// Friendly city name from an IANA id, e.g. "America/Los_Angeles" -> "Los Angeles".
export function zoneCity(timeZone: string): string {
  if (/^Etc\/GMT[+-]\d/.test(timeZone)) return "open ocean";
  if (!timeZone.includes("/") || timeZone.startsWith("Etc/")) return "";
  return timeZone.split("/").pop()!.replace(/_/g, " ");
}

// "UTC−5", "UTC+5:30", "UTC+0".
export function formatUtcOffset(offsetMinutes: number): string {
  const sign = offsetMinutes >= 0 ? "+" : "−";
  const abs = Math.abs(offsetMinutes);
  const mins = abs % 60;
  return `UTC${sign}${Math.floor(abs / 60)}${mins ? ":" + String(mins).padStart(2, "0") : ""}`;
}
